module.exports = __webpack_public_path__ + "static/img/goal-05.1b10956.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/goal-05.png
// module id = C9nE
// module chunks = 2